module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1284.8c661e56.png";